import { GroupPermissionLevel } from "ui/Scripts/source/models/enums";
import { UnitNodePermission } from "./unitNodePermission";

export interface IUnitNodePermissionCompanyGroupPermission {
    permission: number;
    additionalPermissionA: number;
    additionalPermissionB: number;
    additionalPermissionC: number;
    companyGroupPermission: number;
    companyGroupAdditionalPermissionA: number;
    companyGroupAdditionalPermissionB: number;
    companyGroupAdditionalPermissionC: number;
    isExplicitPermission: boolean;

    getTotalUserGroupPermission(): number;
}

export class UnitNodePermissionCompanyGroupPermission implements IUnitNodePermissionCompanyGroupPermission {
    permission: number;
    additionalPermissionA: number;
    additionalPermissionB: number;
    additionalPermissionC: number;
    companyGroupPermission: number;
    companyGroupAdditionalPermissionA: number;
    companyGroupAdditionalPermissionB: number;
    companyGroupAdditionalPermissionC: number;
    isExplicitPermission: boolean;

    constructor();
    constructor(obj: IUnitNodePermissionCompanyGroupPermission);
    constructor(obj?: any) {
        this.permission = obj && obj.permission || GroupPermissionLevel.None;
        this.additionalPermissionA = obj && obj.additionalPermissionA || 0;
        this.additionalPermissionB = obj && obj.additionalPermissionB || 0;
        this.additionalPermissionC = obj && obj.additionalPermissionC || 0;
        this.companyGroupPermission = obj && obj.companyGroupPermission || GroupPermissionLevel.None;
        this.companyGroupAdditionalPermissionA = obj && obj.companyGroupAdditionalPermissionA || 0;
        this.companyGroupAdditionalPermissionB = obj && obj.companyGroupAdditionalPermissionB || 0;
        this.companyGroupAdditionalPermissionC = obj && obj.companyGroupAdditionalPermissionC || 0;
    }

    setUserGroupPermissions(permission: number, additionalPermissionA: number, additionalPermissionB: number, additionalPermissionC: number) {
        this.permission = permission;
        this.additionalPermissionA = additionalPermissionA;
        this.additionalPermissionB = additionalPermissionB;
        this.additionalPermissionC = additionalPermissionC;
    }

    setUserGroupPermissionsFromUnitNodePermission(unitNodePermission: UnitNodePermission) {
        this.setUserGroupPermissions(unitNodePermission.level, unitNodePermission.levelA, unitNodePermission.levelB, unitNodePermission.levelC);
    }

    setCompanyGroupPermissions(companyGroupPermission: number, companyGroupAdditionalPermissionA: number, companyGroupAdditionalPermissionB: number, companyGroupAdditionalPermissionC: number) {
        this.companyGroupPermission = companyGroupPermission;
        this.companyGroupAdditionalPermissionA = companyGroupAdditionalPermissionA;
        this.companyGroupAdditionalPermissionB = companyGroupAdditionalPermissionB;
        this.companyGroupAdditionalPermissionC = companyGroupAdditionalPermissionC;
    }

    getTotalUserGroupPermission(): number {
        return UnitNodePermission.getTotalPermission(this.permission, this.additionalPermissionA, this.additionalPermissionB, this.additionalPermissionC);
    }
}